import useAppTrue from "@/hooks/useAppTrue";
import { AppWrapper } from "@pagegrowler_nextjs";

export const MinimalApp = ({ pageProps, Component }) => {
  const isApp = useAppTrue();

  return (
    <div style={{ marginTop: isApp ? "30px" : "0px" }}>
      <AppWrapper>
        <Component {...pageProps} />
      </AppWrapper>
    </div>
  );
};
